import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import ChartsCurrency from "./Chart/ChartCurrency";
import CurrencyTable from "./Table/CurrencyTable";

const CurrencyInfo = () => {
  const { state } = useLocation();

  const [historyPrices, setHistoryPrices] = useState(
    sessionStorage.getItem(`${state.currency.name}prices`)
      ? JSON.parse(sessionStorage.getItem(`${state.currency.name}prices`))
      : []
  );
  const [historyMonths, setHistoryMonths] = useState(
    sessionStorage.getItem(`${state.currency.name}months`)
      ? JSON.parse(sessionStorage.getItem(`${state.currency.name}months`))
      : []
  );

  const { history } = useSelector((state) => state.main);

  useEffect(() => {
    if (history.length > 0) {
      const helpPrices = [];
      const months = [];
      const monthsInYear = 12;
      const currentDate = history[history.length - 1];
      const currentYear = Number(currentDate.date.slice(0, 4));
      const currentMonth = Number(currentDate.date.slice(5, 7));
      const currentDay = currentDate.date.slice(8, 10);
      const lastYear = currentYear - 1;
      for (let i = currentMonth; i < monthsInYear; i++) {
        calculateMonths(i, lastYear, helpPrices, months);
      }
      for (let i = 0; i < currentMonth; i++) {
        calculateMonths(i, currentYear, helpPrices, months);
      }
      if (currentDay !== '01') {
        let month = currentMonth;
        if (month < 10) {
          month = "0" + month;
        }
        helpPrices.push(+Number(currentDate.priceUsd).toFixed(2));
        months.push(`${currentDay}/${month}/${String(currentYear).slice(2,4)}`);
      }
      setHistoryPrices(helpPrices);
      sessionStorage.setItem(
        `${state.currency.name}prices`,
        JSON.stringify(helpPrices)
      );
      setHistoryMonths(months);
      sessionStorage.setItem(
        `${state.currency.name}months`,
        JSON.stringify(months)
      );
    }
  }, [history]);

  function calculateMonths(i, year, helpPrices, months) {
    let month = i + 1;
    if (month < 10) {
      month = "0" + month;
    }
    const index = history.findIndex(
      (currency) => currency.date === `${year}-${month}-01T00:00:00.000Z`
    );
    if (index !== -1) {
      helpPrices.push(+Number(history[index].priceUsd).toFixed(2));
    } else {
      helpPrices.push(0);
    }
    months.push(`01/${month}/${String(year).slice(2,4)}`);
  }

  return (
    <div>
      <NavLink to="/">
        <Button variant="outline-info">Main</Button>
      </NavLink>
      <CurrencyTable currency={state.currency} />
      <ChartsCurrency
        name={state.currency.name}
        historyPrices={historyPrices}
        historyMonths={historyMonths}
      />
    </div>
  );
};

export default CurrencyInfo;
